export default function getCurrentLanguage() {
    return document.documentElement.lang.substr(0, 2) === 'de'
        ? ''
        : `/${document.documentElement.lang.substr(0, 2)}`;
}
